import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const PujcovnaProtokolTisk = lazy(() =>
  import('@/modules/pujcovna/PujcovnaProtokolTisk').then((m) => ({ default: m.PujcovnaProtokolTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/rezervace/$id/protokol',
  component: () => (
    <Suspense fallback={null}>
      <PujcovnaProtokolTisk />
    </Suspense>
  ),
});
